'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Seasonality.Constants', []).constant('SeasonalityConstants', {
  MIN_OPTIMAL_SEASON: 2,
  MAX_OPTIMAL_SEASON: 5,
  OUTLIER_TOLERANCE: 2,
  MIN_CONTINUOUS_OBS_FOR_SEASON: 3,
  MIN_OUTLIER_RANGE: 0,
  MAX_OUTLIER_RANGE: 5,
  WOY_52: 52,
  WOY_53: 53,
  WOY_0: 0,
  WOY_1: 1,
  DISPLAY_BY_WEEK_MODE: 'displayByWeek',
  DISPLAY_BY_DATE_MODE: 'displayByDate',
  LEVELS: ['Mkt Prod Grp POS', 'Mkt Prod Grp', 'Mkt POS', 'Mkt'],
  SHOW_UP_LEVELS: ['Leg Cabin', 'Leg'],
  LEVEL_TO_SEASONALITY_LEVEL: {
    'Mkt Prod Grp POS': 'MARKET_CLASSGROUP_SPOS',
    'Mkt Prod Grp': 'MARKET_CLASSGROUP',
    'Leg Cabin': 'MARKET_CABIN',
    'Mkt POS': 'MARKET_SPOS',
    'Mkt': 'MARKET',
    'Leg': 'MARKET'
  },
  //to-do check
  METRICS: [{
    label: 'Total Bookings',
    id: 'reservationHoldingsTotal'
  }, {
    label: 'Individual Bookings',
    id: 'reservationHoldingsIdv'
  }, {
    label: 'Revenue',
    id: 'bookedRevenueTotal'
  }, {
    label: 'Unconstrained Individual Bookings',
    id: 'untruncatedReservationHoldings'
  }],
  SHOW_UP_METRICS: [{
    label: 'Load Factor',
    id: 'loadFactor'
  }, {
    label: 'Show-Up Rate',
    id: 'showUpRate'
  }, {
    label: 'Boarding Rate',
    id: 'boardingRate'
  }, {
    label: 'Cancellation Rate',
    id: 'cancellationRate'
  }],
  POOLED_SEASONALITY_METRICS: [{
    label: 'Unconstrained Individual Bookings',
    id: 'untruncatedReservationHoldings'
  }],
  REGRESSION_TERMS: [{
    label: '5',
    id: 5
  }, {
    label: '6',
    id: 6
  }, {
    label: '7',
    id: 7
  }, {
    label: '8',
    id: 8
  }, {
    label: '9',
    id: 9
  }, {
    label: '10',
    id: 10
  }],
  LEARNING_PROCESSES: [{
    label: 'Latest 52 weeks',
    id: 'latest52'
  }, {
    label: 'Additive',
    id: 'additive'
  }],
  METRICS_TO_SEASONALITY_VARIABLE: {
    'Total Bookings': 'Bookings_Total',
    'Individual Bookings': 'Bookings_Individual',
    'Revenue': 'Revenue_Total',
    'Unconstrained Individual Bookings': 'UntruncatedReservationHoldings',
    'Load Factor': 'LoadFactor',
    'Show-Up Rate': 'ShowUpRate',
    'Boarding Rate': 'BoardingRate',
    'Cancellation Rate': 'CancellationRate'
  },
  SEASONALITY_LEVEL_TO_LEVEL: {
    'MARKET_CLASSGROUP_SPOS': 'Mkt Prod Grp POS',
    'MARKET_CLASSGROUP': 'Mkt Prod Grp',
    'MARKET_SPOS': 'Mkt POS',
    'MARKET_CABIN': 'Leg Cabin',
    'MARKET': 'Mkt'
  },
  SEASONALITY_VARIABLE_TO_METRICS: {
    'Bookings_Total': 'Total Bookings',
    'Bookings_Individual': 'Individual Bookings',
    'Revenue_Total': 'Revenue',
    'UntruncatedReservationHoldings': 'Unconstrained Individual Bookings',
    'LoadFactor': 'Load Factor',
    'ShowUpRate': 'Show-Up Rate',
    'BoardingRate': 'Boarding Rate',
    'CancellationRate': 'Cancellation Rate',
    'Offline': 'Offline'
  },
  REVIEW_SEASONALITY_MODES: {
    HISTORICAL: 'historical',
    CURRENT: 'current',
    CURRENT_PLUS: 'currentplus'
  },
  SPECIAL_EVENTS_GRID_ID: 'seasonality-special-events',
  SPECIAL_EVENTS_NEW_CALENDAR_GRID_ID: 'seasonality-new-calendar-special-events',
  CALENDAR_MODES: {
    DEMAND: 'Demand',
    SHOW_UP: 'Show-Up',
    POOLED: 'Pooled Seasonality',
    DA_HSE: 'Holiday and Special Events',
    DA_SEASON: 'Season'
  },
  CALENDAR_STATUSES: {
    NOT_PUBLISHED: 'NOT_PUBLISHED_CALENDAR',
    PUBLISHED: 'PUBLISHED_CALENDAR',
    RUNNING: 'running',
    INACTIVE: 'INACTIVE_CALENDAR',
    COMPLETED: 'completed',
    FINISHED: 'FINISHED-PROCESSING',
    ERROR_PROCESSING: 'error'
  },
  CALENDAR_INIT_STATUSES: {
    STARTED: 'STARTED-PROCESSING',
    NEW: 'NEW-REQUEST',
    ERROR: 'ERROR-PROCESSING',
    FINISHED: 'FINISHED-PROCESSING'
  },
  SPECIAL_EVENT_TYPES: {
    FIXED_DATE: 'Fixed Date',
    FIXED_WOY: 'Fixed WoY',
    MOVING: 'Moving',
    EXCLUDED: 'Excluded',
    USER_EXCLUDED: 'UserExcluded'
  },
  SEASONALITY_TYPE: {
    PARTITIONED: 'partitioned_seasonality',
    POOLED: 'pooled_seasonality'
  },
  FORECAST_TYPES: ['Market', 'Service']
});